<template>
  <div>
    <!-- <dv-full-screen-container> -->
      <!-- <dv-loading v-if="isLoad">Loading...</dv-loading> -->
      <!-- <dv-border-box-11  itle="智慧电表" style="margin: 0 0 10% 0 ; width: 100%; min-height: 300px;"> -->
        <div >
          <el-tabs v-model="activeName" @tab-click="handleClick" stretch="true">
            <el-tab-pane label="设备信息" name="first">
              <el-descriptions class="custom-descriptions" direction="vertical" :column="2" border>
                <el-descriptions-item>
                  <template slot="label">
                    电度值
                  </template>
                  {{ device.dataMeter }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    实际用电度数
                  </template>
                  {{ device.positiveActiveE }} kW·h
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    安装地址
                  </template>
                  {{ device.userAdd }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    状态
                  </template>
                  <el-tag v-show="device.isOff == 0" type="success">开</el-tag>
                  <el-tag v-show="device.isOff == 1" type="danger">关</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    电流比
                  </template>
                  {{ device.currentRatio }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    在线时间
                  </template>
                  {{ device.onlineTime }}
                </el-descriptions-item>
              </el-descriptions>
            </el-tab-pane>
            <el-tab-pane label="数据查询" name="second">
              <div>
                <el-radio-group v-model="historyParam.hisType" style="margin: 0 20px " @change="checkoutType">
                  <el-radio :label='0'>小时</el-radio>
                  <el-radio :label='1'>天</el-radio>
                  <el-radio :label='2'>月</el-radio>
                  <el-radio :label='3'>年</el-radio>
                </el-radio-group>
              </div>
              <electricityHistory :data-history="dataHistory" :date-history="dateHistory" v-if="type == 1"/>
            </el-tab-pane>
          </el-tabs>
        </div>
      <!-- </dv-border-box-11> -->
    <!-- </dv-full-screen-container> -->
  </div>
</template>

<script>
import {getHistory, getInfo} from "../../api/electricity-api";
import electricityHistory from "./electricity-history.vue";

export default {
  name: "electricity",
  components: {electricityHistory},
  data() {
    return {
      activeName: 'first',
      isLoad: true,
      device: {},
      dataHistory: [],
      dateHistory: [],
      historyParam: {
        equipNumber: "",
        hisType: 1
      },
      type: 0
    }
  },
  mounted() {
    this.initData()
  },
  created() {
    // this.initData();
    // this.checkoutType()
  },
  methods: {
    handleClick(tab, event) {
      if (tab.paneName === "second") {
        this.type = 1
        this.checkoutType()
      }
    },
    // 初始化数据
    initData() {
      getInfo(this.$route.query.imei).then(res => {
        if (res.data.code === 200) {
          this.isLoad = false;
        }
        this.device = res.data.data
      })
    },
    checkoutType() {
      this.historyParam.equipNumber = this.$route.query.imei
      getHistory(this.historyParam).then(res => {
        this.dateHistory = res.data.data.dateLists
        this.dataHistory = res.data.data.electricDataLists
      })
    },
  },

}

</script>

<style scoped>
/deep/ .el-descriptions-item__cell{
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/electricity/index.vue